import { Expose, Type } from 'class-transformer';
import { ViewVariantOptionDto } from './view-variant-option.dto';
import { ViewVariantDto } from './view-variant.dto';

export class ViewVariantExtendedDto extends ViewVariantDto {
  @Expose() @Type(() => ViewVariantOptionDto) options: ViewVariantOptionDto[];
}
